import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, User, LogOut, LayoutDashboard } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { IMAGES } from "../lib/api";

const links = [
  { to: "/", label: "Accueil" },
  { to: "/la-carte", label: "La Carte" },
  { to: "/menus-semaine", label: "Menu de la semaine" },
  { to: "/soirees", label: "Soirées" },
  { to: "/terrasse-evenements", label: "Terrasse & Événements" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="glass-header sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-20">
        <Link to="/" data-testid="header-logo-link" className="flex items-center gap-3">
          <img src={IMAGES.logo} alt="Italian Club" className="h-12 w-12 object-contain rounded-full bg-white p-0.5" />
          <div className="hidden sm:block">
            <div className="font-serif-elegant text-xl font-semibold tracking-wide text-[#D4AF37]">ITALIAN CLUB</div>
            <div className="text-[10px] tracking-[0.3em] text-gray-400 uppercase">Bar · Restaurant · Live Music</div>
          </div>
        </Link>
        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.to === "/" ? "home" : l.to.slice(1)}`}
              className={({ isActive }) =>
                `text-sm transition-colors duration-200 ${isActive ? "text-[#D4AF37]" : "text-gray-300 hover:text-white"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          {user && user !== false ? (
            <div className="hidden lg:flex items-center gap-2">
              {["admin","super_admin","staff"].includes(user.role) && (
                <button data-testid="header-admin-btn" onClick={() => navigate("/admin")} className="btn-outline-gold !px-4 !py-2 text-sm">
                  <LayoutDashboard size={16} /> Admin
                </button>
              )}
              <button data-testid="header-profile-btn" onClick={() => navigate("/profil")} className="btn-outline-gold !px-4 !py-2 text-sm">
                <User size={16} /> {user.first_name}
              </button>
              <button data-testid="header-logout-btn" onClick={logout} className="text-gray-400 hover:text-white p-2" title="Déconnexion">
                <LogOut size={18} />
              </button>
            </div>
          ) : (
            <Link to="/connexion" data-testid="header-login-btn" className="hidden lg:inline-flex btn-outline-gold !px-4 !py-2 text-sm">
              <User size={16} /> Connexion
            </Link>
          )}
          <Link to="/reserver" data-testid="header-reserve-btn" className="btn-gold !px-5 !py-2.5 text-sm">
            Réserver
          </Link>
          <button data-testid="mobile-menu-toggle" className="lg:hidden text-white p-2" onClick={() => setOpen(!open)}>
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      {open && (
        <nav data-testid="mobile-menu" className="lg:hidden glass-header border-t border-white/10 px-6 py-6 flex flex-col gap-4">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)} className="text-gray-200 text-base py-1">
              {l.label}
            </NavLink>
          ))}
          {user && user !== false ? (
            <>
              {["admin","super_admin","staff"].includes(user.role) && (
                <NavLink to="/admin" onClick={() => setOpen(false)} className="text-[#D4AF37]">Tableau de bord admin</NavLink>
              )}
              <NavLink to="/profil" onClick={() => setOpen(false)} className="text-[#D4AF37]">Mon profil</NavLink>
              <button onClick={() => { logout(); setOpen(false); }} className="text-left text-gray-400">Déconnexion</button>
            </>
          ) : (
            <NavLink to="/connexion" onClick={() => setOpen(false)} className="text-[#D4AF37]">Connexion / Inscription</NavLink>
          )}
        </nav>
      )}
    </header>
  );
}
